<template>
	<div>
		<template v-if="step === 1">
			<h3 class="color-primary">Neue Terminvorschläge</h3>
			<AppointmentInfos
				:appointment="appointment"
				type="customer"
			/>
			<DateChoiceOrProposal
				v-model="dateChoiceOrProposalData"
				:appointment="appointment"
				type="customer"
			/>
			<PopUpActions
				:with-back="false"
				continue-text="Weiter"
				:continue-disabled="!dateChoiceOrProposalDataValid"
				@continue="step = 2"
			/>
		</template>
		<template v-if="step === 2">
			<template v-if="dateChoiceOrProposalData.counterProposalDates">
				<JonInfo
					v-if="dateChoiceOrProposalData.counterProposalDates.length > 0"
					class="mt-0 mb-2"
				>
					<template #message>
						<div>Bitte überprüfe deine vorgeschlagenen Termine auf Korrektheit:</div>
					</template>
				</JonInfo>
				<div
					v-for="date in dateChoiceOrProposalData.counterProposalDates"
					:key="date.id"
					:class="['font-weight-bold']"
				>
					{{ date | fullDateTimeByDateAndTime }}
				</div>
			</template>
			<JonInfo v-else class="mt-0">
				<template #message>
					Du hast den Termin <b>{{ dateChoiceOrProposalData.chosenDate.timeStamp | fullDateTime }}</b>
					gewählt.<br/>
					Nach Klick auf "Termin bestätigen" informieren wir die Person, dass du den Termin angenommen hast.
				</template>
			</JonInfo>
			<PopUpActions
				:continue-text="dateChoiceOrProposalData.chosenDate ? 'Termin bestätigen' : 'Terminvorschläge schicken'"
				:continue-loading="sendingRequest"
				:continue-disabled="sendingRequest"
				class="mt-3"
				@back="step = 1"
				@continue="sendRequest"
			/>
		</template>
	</div>
</template>

<script>
import AppointmentInfos from "@/vue/communication/conversation/message/reply/AppointmentInfos";
import DateChoiceOrProposal from "@/vue/communication/conversation/message/reply/DateChoiceOrProposal";
import PopUpActions from "@/vue/common/popup/PopUpActions";
import {isDefined} from "@/helper/Value";
import Reply, {
	ACTION_CONFIRM_APPOINTMENT,
	ACTION_SUGGESTING_NEW_DATES
} from "@/api/communication/conversation/message/Reply";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import JonInfo from "@/vue/common/JonInfo.vue";

export default {

	components: {
		JonInfo,
		AppointmentInfos,
		DateChoiceOrProposal,
		PopUpActions,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			step: 1,
			dateChoiceOrProposalData: undefined,
			sendingRequest: false,
		};
	},

	computed: {
		appointment ()
		{
			return this.message.appointment;
		},
		dateChoiceOrProposalDataValid ()
		{
			return isDefined(this.dateChoiceOrProposalData);
		},
	},

	methods: {
		async sendRequest ()
		{
			this.sendingRequest = true;

			try
			{
				const reply = new Reply()
					.setMessageId(this.message.id);

				if (this.dateChoiceOrProposalData.chosenDate)
				{
					reply
						.setAction(ACTION_CONFIRM_APPOINTMENT)
						.setChosenDate(this.dateChoiceOrProposalData.chosenDate.id);
				}
				else
				{
					reply
						.setAction(ACTION_SUGGESTING_NEW_DATES)
						.setCounterProposalDates(this.dateChoiceOrProposalData.counterProposalDates);
				}

				await reply.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		}
	}
}
</script>
